// Import model
import { FilterCalendarEventRequest } from '../models/FilterCalendarEventRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CalendarEventCondition } from '../models/CalendarEventCondition';
import { CalendarEventFields } from '../models/CalendarEventFields';
import { CalendarEventIndexedFields } from '../models/CalendarEventIndexedFields';

// Import dependency serializers (for complex types)
import { CalendarEventConditionSerializer } from './CalendarEventConditionSerializer';
import { CalendarEventFieldsSerializer } from './CalendarEventFieldsSerializer';
import { CalendarEventIndexedFieldsSerializer } from './CalendarEventIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterCalendarEventRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterCalendarEventRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterCalendarEventRequest instance
   */
  static deserialize(json: string): FilterCalendarEventRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterCalendarEventRequest instance
   */
  static fromObject(obj: any): FilterCalendarEventRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterCalendarEventRequest');
    }


    const instance: FilterCalendarEventRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as CalendarEventIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as CalendarEventFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        CalendarEventConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterCalendarEventRequest instances
   */
  static deserializeArray(json: string): FilterCalendarEventRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterCalendarEventRequest instance to a JSON string
   */
  static serialize(instance: FilterCalendarEventRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterCalendarEventRequest instance to a plain object
   */
  static toObject(instance: FilterCalendarEventRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        CalendarEventConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterCalendarEventRequest instances to a JSON string
   */
  static serializeArray(instances: FilterCalendarEventRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
